import styled from "@rentiohq/shared-frontend/dist/components/theme/styled-components";
import CONFIG from "@rentiohq/shared/dist/config/app.config";

export const InnerWrap = styled.div`
  margin-top: 40px;
  margin-left: 16px;
  margin-right: 16px;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    margin-left: 40px;
    margin-right: 40px;
  }
`;

export const Title = styled.span`
  font-size: 17px;
  font-weight: 900;
  color: ${props => props.theme.colors.global1};
`;

export const Subtitle = styled.div`
  margin-top: 16px;
  font-size: 14px;
  color: ${props => props.theme.colors.global1};
`;

export const InfoBox = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 16px;
  background-color: ${props => props.theme.colors.global4};
  border-radius: 6px;
  padding: 8px 16px;
`;

export const InfoWrap = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const QrWrap = styled.div`
  display: none;
  flex-direction: column;
  align-items: center;
  padding-left: 24px;
  border-left: 1px solid ${props => props.theme.colors.global3};
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    display: flex;
  }
`;

export const QrInfoLogos = styled.img`
  margin-top: 6px;
  width: 80px;
`;

export const QrInfoText = styled.div`
  max-width: 160px;
  margin-top: 6px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.colors.global2};
`;

export const InfoBoxRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  margin-top: 12px;
  margin-bottom: 12px;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    flex-direction: row;
  }
`;

export const InfoBoxKey = styled.span`
  flex: 1;
  font-size: 12px;
  font-weight: 500;
  color: ${props => props.theme.colors.global2};
  margin-bottom: 4px;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    margin-bottom: 0px;
  }
`;

export const InfoBoxValue = styled.span`
  flex: 3.5;
  font-size: 16px;
  font-weight: 600;
  color: ${props => props.theme.colors.global1};
`;

export const InfoBoxValueSubtitle = styled.span`
  display: block;
  margin-top: 3px;
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.colors.global2};
`;

export const InfoBoxValueBorder = styled.span`
  border: 2px solid ${props => props.theme.colors.global5};
  border-radius: 4px;
  padding: 2px 4px;
  display: inline-block;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    margin-left: -4px;
  }
`;

export const InfoBoxValueMono = styled.span`
  font-family: monospace;
`;

export const BottomInfo = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: ${props => props.theme.colors.global2};
`;

export const ButtonPrimaryWrap = styled.div``;

export const ButtonBasicWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 8px;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    margin-top: 12px;
  }
`;
